import React, { Component, Fragment } from 'react';
import ReactToPrint from "react-to-print";
import AuthService from './services/AuthService'
import PropTypes from 'prop-types';
import { API } from 'aws-amplify';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import { withSnackbar } from 'notistack';
import moment from 'moment';
import {v4 as uuidv4} from 'uuid/v4';

class ReceiptAll extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      ...props.state
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      ...nextProps.state
    })
  }

  calculatePlanTotal = (plans, isJalan, jalanPaid, extraCharge, discount, gotoDiscount, jalanCoupon, jalanPoint, jalanSubsidy, taxRate) => {
    let gotoDiscountX = "no"
    if(gotoDiscount){
      gotoDiscountX = gotoDiscount
    }

    let total = 0;

    if(jalanPaid === "yes"){
      return total;
    }

    plans.map(n => {
      total += (Number(n.unitPrice) * Number(n.amount))
      return true;
    })

    if(isJalan === "no"){
      total += Number(extraCharge);
      total -= Number(discount);

      if(gotoDiscountX === "yes"){

        total = Math.floor(total * (1 + Number(taxRate))) - Math.ceil(total * (1 + Number(taxRate)) * 0.35)
      }
    }

    if(isJalan === "yes"){
      total -= Number(jalanCoupon);
      total -= Number(jalanPoint);
      total -= Number(jalanSubsidy);
    }


    return total;
  }

  calculateTaxTotal = (plans, isJalan, jalanPaid, extraCharge, discount, gotoDiscount, jalanCoupon, jalanPoint, jalanSubsidy, orders, taxRate) => {
    let gotoDiscountX = "no"
    if(gotoDiscount){
      gotoDiscountX = gotoDiscount
    }

    let tax = 0;

    if(isJalan === "no" && gotoDiscountX === "no"){
      tax += Math.floor(this.calculatePlanTotal(plans, isJalan, jalanPaid, extraCharge, discount, gotoDiscountX, jalanCoupon, jalanPoint, jalanSubsidy, taxRate) * Number(taxRate))
    }

    if(isJalan === "yes"  || gotoDiscountX === "yes"){
      tax += Math.floor(this.calculatePlanTotal(plans, isJalan, jalanPaid, extraCharge, discount, gotoDiscountX, jalanCoupon, jalanPoint, jalanSubsidy, taxRate) * (Number(taxRate)) / (1 + Number(taxRate)))
    }

    tax += Math.floor(this.calculateOrderOuterTaxTotal(orders) * Number(taxRate))

    tax += Math.floor(this.calculateOrderInnerTaxTotal(orders) * (Number(taxRate)) / (1 + Number(taxRate)))

    return tax;

  }

  calculateTotal = (plans, isJalan, jalanPaid, extraCharge, discount, gotoDiscount, jalanCoupon, jalanPoint, jalanSubsidy, orders, taxRate) => {
    let gotoDiscountX = "no"
    if(gotoDiscount){
      gotoDiscountX = gotoDiscount
    }

    let total = 0;

    if(isJalan === "no" && gotoDiscountX === "no"){
      total += Math.floor(this.calculatePlanTotal(plans, isJalan, jalanPaid, extraCharge, discount, gotoDiscountX, jalanCoupon, jalanPoint, jalanSubsidy, taxRate) * (1 + Number(taxRate)))
    }

    if(isJalan === "yes" || gotoDiscountX === "yes"){
      total += this.calculatePlanTotal(plans, isJalan, jalanPaid, extraCharge, discount, gotoDiscountX, jalanCoupon, jalanPoint, jalanSubsidy, taxRate)
    }

    total += Math.floor(this.calculateOrderOuterTaxTotal(orders) * (1 + Number(taxRate)))

    total += this.calculateOrderInnerTaxTotal(orders)

    return total;

  }

  calculateOrderOuterTaxTotal = (orders) => {
    let total = 0;

    orders.map(n => {
      if(n.taxType === "税別"){
        total += Number(n.price) * Number(n.amount)
      }
      return true;
    })

    return total;
  }

  calculateOrderInnerTaxTotal = (orders,taxRate) => {
    let total = 0;

    orders.map(n => {
      if(n.taxType === "税込"){
        total += Number(n.price) * Number(n.amount)
      }
      return true;
    })

    return total;
  }

  returnCompornent = (title) => {
    return (
      <div>
        {this.state.reservations.map((n, i) =>{

          let rooms = "";
          for(let i in n.input_rooms){
            rooms = rooms + n.input_rooms[i]
            if(i !== n.input_rooms.length - 1){
              rooms = rooms + " "
            }
          }

          let date = moment(this.state[n.reservation_id + "IssueDate"]).format("YYYY年 M月 D日");

          return(
            <div className="body" key={n.reservation_id}>
            <link rel="stylesheet" href="../css/Receipts.css" />
              <div className="clearfix" key={n.reservation_id + "2"}>
                <div id="logo">
                  <img src="../images/funwarikon.png" alt="logo" />
                </div>
                <h1 style={{ background: 'url("/images/leaves.png")'}}>{title}</h1>
                <div id="company" className="clearfix">
                  <div>ペンション ふんわりこん</div>
                  <div>〒410-1231<br/>静岡県裾野市須山2255-3810</div>
                  <div>☎ 055-998-1433</div>
                </div>

                <div id="project">
                  <div id="name"><div><span>御芳名</span>{n.last_name} {n.first_name} 様</div></div>
                  <div id="total"><div><span>金額</span>¥{this.calculateTotal(n.plans, n.is_jalan, n.jalan_paid, n.extra_charge, n.discount,  n.goto_discount, n.jalan_coupon, n.jalan_point, n.jalan_subsidy, n.orders, n.tax_rate).toLocaleString()}ー</div></div>
                  <div id="tadashi">
                    但し、ご宿泊代金およびご飲食費として、上記の金額を正に領収いたしました。
                    {this.state[n.reservation_id + "CreditCheck"] === "yes" ? "【クレジットカード利用】" : ""}
                    <br/>
                    {this.state[n.reservation_id + "ReceiptNote"]}
                  </div>
                  <div><span>発行日</span>{date}</div>
                  <div><span>領収書No.</span>{this.state[n.reservation_id + "ReceiptNumber"]}</div>
                </div>
              </div>
              <main>
                <table>
                  <thead>
                    <tr>
                      <th className="desc">ご利用明細</th>
                      <th>単価</th>
                      <th>数量</th>
                      <th>小計</th>
                    </tr>
                  </thead>

                  <tbody key={n.reservation_id}>


                    {n.plans.map((m,i) => {
                      if(n.is_jalan === "no"){
                        return(
                          <tr key={"notJalan" + i}>
                            <td className="desc">{m.basePlan}ご宿泊料({m.mealPlan}・ベッド{m.bedPlan})</td>
                            <td className="unit">￥{Number(m.unitPrice).toLocaleString()}</td>
                            <td className="qty">{m.amount}</td>
                            <td className="total">￥{(Number(m.unitPrice) * Number(m.amount)).toLocaleString()}</td>
                          </tr>
                        )
                      }

                      if(n.is_jalan === "yes"){
                        return(
                          <tr key={"jalan" + i}>
                            <td className="desc">{m.basePlan}ご宿泊料({m.mealPlan}・ベッド{m.bedPlan})</td>
                            <td className="unit">￥{Number(m.unitPrice).toLocaleString()}</td>
                            <td className="qty">{m.amount}</td>
                            <td className="total">￥{(Number(m.unitPrice) * Number(m.amount)).toLocaleString()}</td>
                          </tr>
                        )
                      }

                      return true;

                    })}


                    {(() => {

                      if (n.is_jalan === "no" && n.extra_charge && n.discount){
                        return (
                          <Fragment>
                            <tr>
                              <td className="desc">その他サービス料</td>
                              <td className="unit"></td>
                              <td className="qty"></td>
                              <td className="total">¥{Number(n.extra_charge).toLocaleString()}</td>
                            </tr>
                            <tr>
                              <td className="desc">割引額</td>
                              <td className="unit"></td>
                              <td className="qty"></td>
                              <td className="total">¥-{Number(n.discount).toLocaleString()}</td>
                            </tr>
                          </Fragment>
                        )
                      }

                      if (n.is_jalan === "no" && n.extra_charge){
                        return (
                          <tr>
                            <td className="desc">その他サービス料</td>
                            <td className="unit"></td>
                            <td className="qty"></td>
                            <td className="total">¥{Number(n.extra_charge).toLocaleString()}</td>
                          </tr>
                        )
                      }

                      if (n.is_jalan === "no" && n.discount){
                        return (
                          <tr>
                            <td className="desc">割引額</td>
                            <td className="unit"></td>
                            <td className="qty"></td>
                            <td className="total">¥-{Number(n.discount).toLocaleString()}</td>
                          </tr>
                        )
                      }


                      if (n.is_jalan === "yes" && n.jalan_coupon && n.jalan_point && n.jalan_subsidy){
                        return (
                          <Fragment>
                            <tr>
                              <td className="desc">じゃらんクーポン利用額</td>
                              <td className="unit"></td>
                              <td className="qty"></td>
                              <td className="total">¥-{n.jalan_coupon}</td>
                            </tr>
                            <tr>
                              <td className="desc">じゃらんポイント利用額</td>
                              <td className="unit"></td>
                              <td className="qty"></td>
                              <td className="total">¥-{n.jalan_point}</td>
                            </tr>
                            <tr>
                              <td className="desc">補助金利用額</td>
                              <td className="unit"></td>
                              <td className="qty"></td>
                              <td className="total">¥-{n.jalan_subsidy}</td>
                            </tr>
                          </Fragment>
                        )
                      }

                      if (n.is_jalan === "yes" && n.jalan_coupon && n.jalan_point){
                        return (
                          <Fragment>
                            <tr>
                              <td className="desc">じゃらんクーポン利用額</td>
                              <td className="unit"></td>
                              <td className="qty"></td>
                              <td className="total">¥-{n.jalan_coupon}</td>
                            </tr>
                            <tr>
                              <td className="desc">じゃらんポイント利用額</td>
                              <td className="unit"></td>
                              <td className="qty"></td>
                              <td className="total">¥-{n.jalan_point}</td>
                            </tr>
                            </Fragment>
                        )
                      }

                      if (n.is_jalan === "yes" && n.jalan_coupon && n.jalan_subsidy){
                        return (
                          <Fragment>
                            <tr>
                              <td className="desc">じゃらんクーポン利用額</td>
                              <td className="unit"></td>
                              <td className="qty"></td>
                              <td className="total">¥-{n.jalan_coupon}</td>
                            </tr>
                            <tr>
                              <td className="desc">補助金利用額</td>
                              <td className="unit"></td>
                              <td className="qty"></td>
                              <td className="total">¥-{n.jalan_subsidy}</td>
                            </tr>
                          </Fragment>
                        )
                      }

                      if (n.is_jalan === "yes" && n.jalan_point && n.jalan_subsidy){
                        return (
                          <Fragment>
                            <tr>
                              <td className="desc">じゃらんポイント利用額</td>
                              <td className="unit"></td>
                              <td className="qty"></td>
                              <td className="total">¥-{n.jalan_point}</td>
                            </tr>
                            <tr>
                              <td className="desc">補助金利用額</td>
                              <td className="unit"></td>
                              <td className="qty"></td>
                              <td className="total">¥-{n.jalan_subsidy}</td>
                            </tr>
                          </Fragment>
                        )
                      }

                      if (n.is_jalan === "yes" && n.jalan_coupon){
                        return (
                          <tr>
                            <td className="desc">じゃらんクーポン利用額</td>
                            <td className="unit"></td>
                            <td className="qty"></td>
                            <td className="total">¥-{n.jalan_coupon}</td>
                          </tr>
                        )
                      }

                      if (n.is_jalan === "yes" && n.jalan_point){
                        return (
                          <tr>
                            <td className="desc">じゃらんポイント利用額</td>
                            <td className="unit"></td>
                            <td className="qty"></td>
                            <td className="total">¥-{n.jalan_point}</td>
                          </tr>
                        )
                      }

                      if (n.is_jalan === "yes" && n.jalan_subsidy){
                        return (
                          <tr>
                            <td className="desc">補助金利用額</td>
                            <td className="unit"></td>
                            <td className="qty"></td>
                            <td className="total">¥-{n.jalan_subsidy}</td>
                          </tr>
                        )
                      }

                     })()}


                     {(() => {
                        if (n.is_jalan === "yes" && n.jalan_paid === "yes"){
                          return (
                            <tr>
                              <td className="desc">じゃらんお支払い済み金額</td>
                              <td className="unit"></td>
                              <td className="qty"></td>
                              <td className="total">¥-{this.calculatePlanTotal(n.plans, n.is_jalan, "no", n.extra_charge, n.discount, n.goto_discount, n.jalan_coupon, n.jalan_point, n.jalan_subsidy, n.tax_rate).toLocaleString()}</td>
                            </tr>
                          )
                        }
                      })()}

                      {(() => {
                         if (n.goto_discount === "yes"){
                           return (
                             <tr>
                               <td className="desc">GoToキャンペーン割引額</td>
                               <td className="unit"></td>
                               <td className="qty"></td>
                               <td className="total">¥-{Math.ceil(this.calculatePlanTotal(n.plans, n.is_jalan, n.jalan_paid, n.extra_charge, n.discount, "no", n.jalan_coupon, n.jalan_point, n.jalan_subsidy, n.tax_rate) * 1.1 * 0.35).toLocaleString()}</td>
                             </tr>
                           )
                         }
                       })()}

                    <tr>
                      <td colSpan="3">ご宿泊代小計</td>
                      <td className="total">￥{this.calculatePlanTotal(n.plans, n.is_jalan, n.jalan_paid, n.extra_charge, n.discount, n.goto_discount, n.jalan_coupon, n.jalan_point, n.jalan_subsidy, n.tax_rate).toLocaleString()}</td>
                    </tr>

                    {(() => {
                       if ((n.is_jalan === "yes" && n.jalan_paid === "no") || n.goto_discount === "yes"){
                         return (
                           <tr>
                             <td colSpan="3">(内消費税</td>
                             <td className="total">¥{
                               Math.floor(this.calculatePlanTotal(n.plans, n.is_jalan, n.jalan_paid, n.extra_charge, n.discount, n.goto_discount, n.jalan_coupon, n.jalan_point, n.jalan_subsidy, n.tax_rate) * (Number(n.tax_rate)) / (1 + Number(n.tax_rate))).toLocaleString()
                             })</td>
                           </tr>
                         )
                       }
                     })()}


                    <tr>
                      <td colSpan="4"></td>
                    </tr>



                    {(() => {
                       if (this.calculateOrderOuterTaxTotal(n.orders) > 0){
                         return (
                           <Fragment>
                             {n.orders.map((m,i) => {
                               if(m.taxType === "税別"){
                                 return(
                                   <tr key={m.name + i}>
                                     <td className="desc">{m.name}</td>
                                     <td className="unit">￥{Number(m.price).toLocaleString()}</td>
                                     <td className="qty">{m.amount}</td>
                                     <td className="total">￥{(Number(m.price) * Number(m.amount)).toLocaleString()}</td>
                                   </tr>
                                 )
                               }
                               return true;
                              })}
                              <tr>
                                <td colSpan="3">税別ご飲食費小計</td>
                                <td className="total">¥{this.calculateOrderOuterTaxTotal(n.orders).toLocaleString()}</td>
                              </tr>
                              <tr>
                                <td className="desc"></td>
                                <td className="unit"></td>
                                <td className="qty"></td>
                                <td className="total"></td>
                              </tr>
                            </Fragment>
                         )
                       }
                    })()}

                   {(() => {
                      if (this.calculateOrderInnerTaxTotal(n.orders) > 0){
                        return (
                          <Fragment>
                            {n.orders.map((m,i) => {
                              if(m.taxType === "税込"){
                                return(
                                  <tr key={m.name + i}>
                                    <td className="desc">{m.name}</td>
                                    <td className="unit">￥{Number(m.price).toLocaleString()}</td>
                                    <td className="qty">{m.amount}</td>
                                    <td className="total">￥{(Number(m.price) * Number(m.amount)).toLocaleString()}</td>
                                  </tr>
                                )
                              }
                              return true;
                            })}
                            <tr>
                              <td colSpan="3">税込ご飲食費小計</td>
                              <td className="total">¥{this.calculateOrderInnerTaxTotal(n.orders).toLocaleString()}</td>
                            </tr>
                            <tr>
                              <td colSpan="3">(内消費税</td>
                              <td className="total">¥{
                                Math.floor(this.calculateOrderInnerTaxTotal(n.orders) * (Number(n.tax_rate)) / (1 + Number(n.tax_rate))).toLocaleString()
                              })</td>
                            </tr>
                            <tr>
                              <td className="desc"></td>
                              <td className="unit"></td>
                              <td className="qty"></td>
                              <td className="total"></td>
                            </tr>
                           </Fragment>
                        )
                      }
                    })()}

                    <tr>
                      <td colSpan="3">消費税等小計 ({Number(n.tax_rate) * 100}%)</td>
                      <td className="total">¥{this.calculateTaxTotal(n.plans, n.is_jalan, n.jalan_paid, n.extra_charge, n.discount, n.goto_discount, n.jalan_coupon, n.jalan_point, n.jalan_subsidy, n.orders, n.tax_rate).toLocaleString()}</td>
                    </tr>
                    <tr>
                      <td colSpan="3" className="grand total">合計金額</td>
                      <td className="grand total">￥{this.calculateTotal(n.plans, n.is_jalan, n.jalan_paid, n.extra_charge, n.discount, n.goto_discount, n.jalan_coupon, n.jalan_point, n.jalan_subsidy, n.orders, n.tax_rate).toLocaleString()}</td>
                    </tr>
                  </tbody>
                </table>
              </main>
              <div className="footer">
                このたびは、ご利用誠にありがとうございました。<br/>{n.last_name} {n.first_name} 様のまたのご利用を心よりお待ちしております。<br/>どうぞ、お気をつけてお帰りくださいませ。
              </div>
            </div>
          )
        })}
      </div>
    )
  }


  render() {
    return (

      <div>
        {this.returnCompornent("領収書 兼 ご利用明細書")}
        {this.returnCompornent("領収書 兼 ご利用明細書 【店舗控】")}
      </div>
    );
  }
}


class Receipt extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      ...props.state
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      ...nextProps.state
    })
  }

  calculatePlanTotal = (plans, isJalan, jalanPaid, extraCharge, discount, gotoDiscount, jalanCoupon, jalanPoint, jalanSubsidy, taxRate) => {
    let gotoDiscountX = "no"
    if(gotoDiscount){
      gotoDiscountX = gotoDiscount
    }

    let total = 0;

    if(jalanPaid === "yes"){
      return total;
    }

    plans.map(n => {
      total += (Number(n.unitPrice) * Number(n.amount))
      return true;
    })

    if(isJalan === "no"){
      total += Number(extraCharge);
      total -= Number(discount);

      if(gotoDiscountX === "yes"){

        total = Math.floor(total * (1 + Number(taxRate))) - Math.ceil(total * (1 + Number(taxRate)) * 0.35)
      }
    }

    if(isJalan === "yes"){
      total -= Number(jalanCoupon);
      total -= Number(jalanPoint);
      total -= Number(jalanSubsidy);
    }


    return total;
  }

  calculateTaxTotal = (plans, isJalan, jalanPaid, extraCharge, discount, gotoDiscount, jalanCoupon, jalanPoint, jalanSubsidy, orders, taxRate) => {
    let gotoDiscountX = "no"
    if(gotoDiscount){
      gotoDiscountX = gotoDiscount
    }

    let tax = 0;

    if(isJalan === "no" && gotoDiscountX === "no"){
      tax += Math.floor(this.calculatePlanTotal(plans, isJalan, jalanPaid, extraCharge, discount, gotoDiscountX, jalanCoupon, jalanPoint, jalanSubsidy, taxRate) * Number(taxRate))
    }

    if(isJalan === "yes"  || gotoDiscountX === "yes"){
      tax += Math.floor(this.calculatePlanTotal(plans, isJalan, jalanPaid, extraCharge, discount, gotoDiscountX, jalanCoupon, jalanPoint, jalanSubsidy, taxRate) * (Number(taxRate)) / (1 + Number(taxRate)))
    }

    tax += Math.floor(this.calculateOrderOuterTaxTotal(orders) * Number(taxRate))

    tax += Math.floor(this.calculateOrderInnerTaxTotal(orders) * (Number(taxRate)) / (1 + Number(taxRate)))

    return tax;

  }

  calculateTotal = (plans, isJalan, jalanPaid, extraCharge, discount, gotoDiscount, jalanCoupon, jalanPoint, jalanSubsidy, orders, taxRate) => {
    let gotoDiscountX = "no"
    if(gotoDiscount){
      gotoDiscountX = gotoDiscount
    }

    let total = 0;

    if(isJalan === "no" && gotoDiscountX === "no"){
      total += Math.floor(this.calculatePlanTotal(plans, isJalan, jalanPaid, extraCharge, discount, gotoDiscountX, jalanCoupon, jalanPoint, jalanSubsidy, taxRate) * (1 + Number(taxRate)))
    }

    if(isJalan === "yes" || gotoDiscountX === "yes"){
      total += this.calculatePlanTotal(plans, isJalan, jalanPaid, extraCharge, discount, gotoDiscountX, jalanCoupon, jalanPoint, jalanSubsidy, taxRate)
    }

    total += Math.floor(this.calculateOrderOuterTaxTotal(orders) * (1 + Number(taxRate)))

    total += this.calculateOrderInnerTaxTotal(orders)

    return total;

  }

  calculateOrderOuterTaxTotal = (orders) => {
    let total = 0;

    orders.map(n => {
      if(n.taxType === "税別"){
        total += Number(n.price) * Number(n.amount)
      }
      return true;
    })

    return total;
  }

  calculateOrderInnerTaxTotal = (orders,taxRate) => {
    let total = 0;

    orders.map(n => {
      if(n.taxType === "税込"){
        total += Number(n.price) * Number(n.amount)
      }
      return true;
    })

    return total;
  }

  returnCompornent = (title) => {
    return (
      <div>
        {this.state.reservationsToPrint.map((n, i) =>{

          let rooms = "";
          for(let i in n.input_rooms){
            rooms = rooms + n.input_rooms[i]
            if(i !== n.input_rooms.length - 1){
              rooms = rooms + " "
            }
          }

          let date = moment(this.state[n.reservation_id + "IssueDate"]).format("YYYY年 M月 D日");

          if(this.state.reservationsToPrint.length > 0){
            return(
              <div className="body" key={n.reservation_id}>
              <link rel="stylesheet" href="../css/Receipts.css" />
                <div className="clearfix" key={n.reservation_id + "2"}>
                  <div id="logo">
                    <img src="../images/funwarikon.png" alt="logo" />
                  </div>
                  <h1 style={{ background: 'url("/images/leaves.png")'}}>{title}</h1>
                  <div id="company" className="clearfix">
                    <div>ペンション ふんわりこん</div>
                    <div>〒410-1231<br/>静岡県裾野市須山2255-3810</div>
                    <div>☎ 055-998-1433</div>
                  </div>

                  <div id="project">
                    <div id="name"><div><span>御芳名</span>{n.last_name} {n.first_name} 様</div></div>
                    <div id="total"><div><span>金額</span>¥{this.calculateTotal(n.plans, n.is_jalan, n.jalan_paid, n.extra_charge, n.discount, n.goto_discount, n.jalan_coupon, n.jalan_point, n.jalan_subsidy, n.orders, n.tax_rate).toLocaleString()}ー</div></div>
                    <div id="tadashi">
                      但し、ご宿泊代金およびご飲食費として、上記の金額を正に領収いたしました。
                      {this.state[n.reservation_id + "CreditCheck"] === "yes" ? "【クレジットカード利用】" : ""}
                      <br/>
                      {this.state[n.reservation_id + "ReceiptNote"]}
                    </div>
                    <div><span>発行日</span>{date}</div>
                    <div><span>領収書No.</span>{this.state[n.reservation_id + "ReceiptNumber"]}</div>
                  </div>
                </div>
                <main>
                  <table>
                    <thead>
                      <tr>
                        <th className="desc">ご利用明細</th>
                        <th>単価</th>
                        <th>数量</th>
                        <th>小計</th>
                      </tr>
                    </thead>

                    <tbody key={n.reservation_id}>


                      {n.plans.map((m,i) => {
                        if(n.is_jalan === "no"){
                          return(
                            <tr key={"notJalan" + i}>
                              <td className="desc">{m.basePlan}ご宿泊料({m.mealPlan === "無" ? "お食事無し" : m.mealPlan}・ベッド{m.bedPlan})</td>
                              <td className="unit">￥{Number(m.unitPrice).toLocaleString()}</td>
                              <td className="qty">{m.amount}</td>
                              <td className="total">￥{(Number(m.unitPrice) * Number(m.amount)).toLocaleString()}</td>
                            </tr>
                          )
                        }

                        if(n.is_jalan === "yes"){
                          return(
                            <tr key={"jalan" + i}>
                              <td className="desc">{m.basePlan}ご宿泊料({m.mealPlan}・ベッド{m.bedPlan})</td>
                              <td className="unit">￥{Number(m.unitPrice).toLocaleString()}</td>
                              <td className="qty">{m.amount}</td>
                              <td className="total">￥{(Number(m.unitPrice) * Number(m.amount)).toLocaleString()}</td>
                            </tr>
                          )
                        }

                        return true;

                      })}


                      {(() => {

                        if (n.is_jalan === "no" && n.extra_charge && n.discount){
                          return (
                            <Fragment>
                              <tr>
                                <td className="desc">その他サービス料</td>
                                <td className="unit"></td>
                                <td className="qty"></td>
                                <td className="total">¥{Number(n.extra_charge).toLocaleString()}</td>
                              </tr>
                              <tr>
                                <td className="desc">割引額</td>
                                <td className="unit"></td>
                                <td className="qty"></td>
                                <td className="total">¥-{Number(n.discount).toLocaleString()}</td>
                              </tr>
                            </Fragment>
                          )
                        }

                        if (n.is_jalan === "no" && n.extra_charge){
                          return (
                            <tr>
                              <td className="desc">その他サービス料</td>
                              <td className="unit"></td>
                              <td className="qty"></td>
                              <td className="total">¥{Number(n.extra_charge).toLocaleString()}</td>
                            </tr>
                          )
                        }

                        if (n.is_jalan === "no" && n.discount){
                          return (
                            <tr>
                              <td className="desc">割引額</td>
                              <td className="unit"></td>
                              <td className="qty"></td>
                              <td className="total">¥-{Number(n.discount).toLocaleString()}</td>
                            </tr>
                          )
                        }


                        if (n.is_jalan === "yes" && n.jalan_coupon && n.jalan_point && n.jalan_subsidy){
                          return (
                            <Fragment>
                              <tr>
                                <td className="desc">じゃらんクーポン利用額</td>
                                <td className="unit"></td>
                                <td className="qty"></td>
                                <td className="total">¥-{n.jalan_coupon}</td>
                              </tr>
                              <tr>
                                <td className="desc">じゃらんポイント利用額</td>
                                <td className="unit"></td>
                                <td className="qty"></td>
                                <td className="total">¥-{n.jalan_point}</td>
                              </tr>
                              <tr>
                                <td className="desc">補助金利用額</td>
                                <td className="unit"></td>
                                <td className="qty"></td>
                                <td className="total">¥-{n.jalan_subsidy}</td>
                              </tr>
                            </Fragment>
                          )
                        }

                        if (n.is_jalan === "yes" && n.jalan_coupon && n.jalan_point){
                          return (
                            <Fragment>
                              <tr>
                                <td className="desc">じゃらんクーポン利用額</td>
                                <td className="unit"></td>
                                <td className="qty"></td>
                                <td className="total">¥-{n.jalan_coupon}</td>
                              </tr>
                              <tr>
                                <td className="desc">じゃらんポイント利用額</td>
                                <td className="unit"></td>
                                <td className="qty"></td>
                                <td className="total">¥-{n.jalan_point}</td>
                              </tr>
                              </Fragment>
                          )
                        }

                        if (n.is_jalan === "yes" && n.jalan_coupon && n.jalan_subsidy){
                          return (
                            <Fragment>
                              <tr>
                                <td className="desc">じゃらんクーポン利用額</td>
                                <td className="unit"></td>
                                <td className="qty"></td>
                                <td className="total">¥-{n.jalan_coupon}</td>
                              </tr>
                              <tr>
                                <td className="desc">補助金利用額</td>
                                <td className="unit"></td>
                                <td className="qty"></td>
                                <td className="total">¥-{n.jalan_subsidy}</td>
                              </tr>
                            </Fragment>
                          )
                        }

                        if (n.is_jalan === "yes" && n.jalan_point && n.jalan_subsidy){
                          return (
                            <Fragment>
                              <tr>
                                <td className="desc">じゃらんポイント利用額</td>
                                <td className="unit"></td>
                                <td className="qty"></td>
                                <td className="total">¥-{n.jalan_point}</td>
                              </tr>
                              <tr>
                                <td className="desc">補助金利用額</td>
                                <td className="unit"></td>
                                <td className="qty"></td>
                                <td className="total">¥-{n.jalan_subsidy}</td>
                              </tr>
                            </Fragment>
                          )
                        }

                        if (n.is_jalan === "yes" && n.jalan_coupon){
                          return (
                            <tr>
                              <td className="desc">じゃらんクーポン利用額</td>
                              <td className="unit"></td>
                              <td className="qty"></td>
                              <td className="total">¥-{n.jalan_coupon}</td>
                            </tr>
                          )
                        }

                        if (n.is_jalan === "yes" && n.jalan_point){
                          return (
                            <tr>
                              <td className="desc">じゃらんポイント利用額</td>
                              <td className="unit"></td>
                              <td className="qty"></td>
                              <td className="total">¥-{n.jalan_point}</td>
                            </tr>
                          )
                        }

                        if (n.is_jalan === "yes" && n.jalan_subsidy){
                          return (
                            <tr>
                              <td className="desc">補助金利用額</td>
                              <td className="unit"></td>
                              <td className="qty"></td>
                              <td className="total">¥-{n.jalan_subsidy}</td>
                            </tr>
                          )
                        }

                       })()}


                       {(() => {
                          if (n.is_jalan === "yes" && n.jalan_paid === "yes"){
                            return (
                              <tr>
                                <td className="desc">じゃらんお支払い済み金額</td>
                                <td className="unit"></td>
                                <td className="qty"></td>
                                <td className="total">¥-{this.calculatePlanTotal(n.plans, n.is_jalan, "no", n.extra_charge, n.discount, n.goto_discount, n.jalan_coupon, n.jalan_point, n.jalan_subsidy, n.tax_rate).toLocaleString()}</td>
                              </tr>
                            )
                          }
                        })()}

                        {(() => {
                           if (n.goto_discount === "yes"){
                             return (
                               <tr>
                                 <td className="desc">GoToキャンペーン割引額</td>
                                 <td className="unit"></td>
                                 <td className="qty"></td>
                                 <td className="total">¥-{Math.ceil(this.calculatePlanTotal(n.plans, n.is_jalan, n.jalan_paid, n.extra_charge, n.discount, "no", n.jalan_coupon, n.jalan_point, n.jalan_subsidy, n.tax_rate) * 1.1 * 0.35).toLocaleString()}</td>
                               </tr>
                             )
                           }
                         })()}

                      <tr>
                        <td colSpan="3">ご宿泊代小計</td>
                        <td className="total">￥{this.calculatePlanTotal(n.plans, n.is_jalan, n.jalan_paid, n.extra_charge, n.discount, n.goto_discount, n.jalan_coupon, n.jalan_point, n.jalan_subsidy, n.tax_rate).toLocaleString()}</td>
                      </tr>

                      {(() => {
                         if ((n.is_jalan === "yes" && n.jalan_paid === "no") || n.goto_discount === "yes"){
                           return (
                             <tr>
                               <td colSpan="3">(内消費税</td>
                               <td className="total">¥{
                                 Math.floor(this.calculatePlanTotal(n.plans, n.is_jalan, n.jalan_paid, n.extra_charge, n.discount, n.goto_discount, n.jalan_coupon, n.jalan_point, n.jalan_subsidy, n.tax_rate) * (Number(n.tax_rate)) / (1 + Number(n.tax_rate))).toLocaleString()
                               })</td>
                             </tr>
                           )
                         }
                       })()}


                      <tr>
                        <td colSpan="4"></td>
                      </tr>



                      {(() => {
                         if (this.calculateOrderOuterTaxTotal(n.orders) > 0){
                           return (
                             <Fragment>
                               {n.orders.map((m,i) => {
                                 if(m.taxType === "税別"){
                                   return(
                                     <tr key={m.name + i}>
                                       <td className="desc">{m.name}</td>
                                       <td className="unit">￥{Number(m.price).toLocaleString()}</td>
                                       <td className="qty">{m.amount}</td>
                                       <td className="total">￥{(Number(m.price) * Number(m.amount)).toLocaleString()}</td>
                                     </tr>
                                   )
                                 }
                                 return true;
                                })}
                                <tr>
                                  <td colSpan="3">税別ご飲食費小計</td>
                                  <td className="total">¥{this.calculateOrderOuterTaxTotal(n.orders).toLocaleString()}</td>
                                </tr>
                                <tr>
                                  <td className="desc"></td>
                                  <td className="unit"></td>
                                  <td className="qty"></td>
                                  <td className="total"></td>
                                </tr>
                              </Fragment>
                           )
                         }
                      })()}

                     {(() => {
                        if (this.calculateOrderInnerTaxTotal(n.orders) > 0){
                          return (
                            <Fragment>
                              {n.orders.map((m,i) => {
                                if(m.taxType === "税込"){
                                  return(
                                    <tr key={m.name + i}>
                                      <td className="desc">{m.name}</td>
                                      <td className="unit">￥{Number(m.price).toLocaleString()}</td>
                                      <td className="qty">{m.amount}</td>
                                      <td className="total">￥{(Number(m.price) * Number(m.amount)).toLocaleString()}</td>
                                    </tr>
                                  )
                                }
                                return true;
                              })}
                              <tr>
                                <td colSpan="3">税込ご飲食費小計</td>
                                <td className="total">¥{this.calculateOrderInnerTaxTotal(n.orders).toLocaleString()}</td>
                              </tr>
                              <tr>
                                <td colSpan="3">(内消費税</td>
                                <td className="total">¥{
                                  Math.floor(this.calculateOrderInnerTaxTotal(n.orders) * (Number(n.tax_rate)) / (1 + Number(n.tax_rate))).toLocaleString()
                                })</td>
                              </tr>
                              <tr>
                                <td className="desc"></td>
                                <td className="unit"></td>
                                <td className="qty"></td>
                                <td className="total"></td>
                              </tr>
                             </Fragment>
                          )
                        }
                      })()}

                      <tr>
                        <td colSpan="3">消費税等小計 ({Number(n.tax_rate) * 100}%)</td>
                        <td className="total">¥{this.calculateTaxTotal(n.plans, n.is_jalan, n.jalan_paid, n.extra_charge, n.discount, n.goto_discount, n.jalan_coupon, n.jalan_point, n.jalan_subsidy, n.orders, n.tax_rate).toLocaleString()}</td>
                      </tr>
                      <tr>
                        <td colSpan="3" className="grand total">合計金額</td>
                        <td className="grand total">￥{this.calculateTotal(n.plans, n.is_jalan, n.jalan_paid, n.extra_charge, n.discount, n.goto_discount, n.jalan_coupon, n.jalan_point, n.jalan_subsidy, n.orders, n.tax_rate).toLocaleString()}</td>
                      </tr>
                    </tbody>
                  </table>
                </main>
                <div className="footer">
                  このたびは、ご利用誠にありがとうございました。<br/>{n.last_name} {n.first_name} 様のまたのご利用を心よりお待ちしております。<br/>どうぞ、お気をつけてお帰りくださいませ。
                </div>
              </div>
            )
          }
          return true;
        })}
      </div>
    )
  }


  render() {
    return (

      <div>
        {this.returnCompornent("領収書 兼 ご利用明細書")}
        {this.returnCompornent("領収書 兼 ご利用明細書 【店舗控】")}
      </div>
    );
  }
}

const styles = theme => ({
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    maxWidth: 900,
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginleft: theme.spacing.unit,
    marginTop: 0,
    width: 300,
  },
  menuButton:{
    margin:5
  },
  longTableCell:{
    color: "#676767",
    maxWidth: 380,
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
  }
});

const initialState = {
  reservations: [],
  reservationIdsToPrint:[],
  reservationsToPrint: [],
  receiptNumbers: [],
  receiptNumbersToPrint: [],
};


class IssueReceipts extends Component {

  constructor(props) {
    super(props);
    this.state = initialState;
    this.authApi = new AuthService();
  }

  componentWillMount(){

    this.authApi.isLogin()
    .then(
      (login) => {
        if(!login){
          this.props.history.push('/login');
        }
      }
    );

    let apiName = 'MyAPIGatewayAPI';
    let path = '/search-reservations-for-receipts';

    API.get(apiName, path).then(response => {

      console.log(response)

      this.setState({
        reservations: response.reservations
      }, () => {
        this.state.reservations.map(n => {

          this.setState({
            [ n.reservation_id + "PrintCheck" ] : "no",
            [ n.reservation_id + "ReceiptNote" ] : "",
            [ n.reservation_id + "CreditCheck" ] : "no",
            [ n.reservation_id + "ReceiptNumber" ] : uuidv4() + "-" + n.date,
            [ n.reservation_id + "IssueDate" ] : moment(n.date).add(Number(n.date_num), 'days').format("YYYY-MM-DD"),
          })
          return true;
        })
      })

    }).catch(error => {
      console.log(error);
    })
  }

  handleChange = (event, key) => {
    this.setState({
      [key] : event.target.value
    });
  }

  handleChangeCheck = (event, key) => {
    let check = event.target.checked;

    let strCheck = key.slice(-10);
    let reservationIdsToPrint = this.state.reservationIdsToPrint;

    if(strCheck === "PrintCheck" && event.target.checked){
      let reservationId = key.slice(0, 38);
      reservationIdsToPrint.push(reservationId);
    }

    if(strCheck === "PrintCheck" && !event.target.checked){
      let reservationId = key.slice(0, 38);
      reservationIdsToPrint = reservationIdsToPrint.filter(n => n !== reservationId);
    }

    let reservationsToPrint = [];

    reservationIdsToPrint.map(n => {

      let reservation = this.state.reservations.find(m => {
        if(m.reservation_id === n) return true;
        return false;
      })

      reservationsToPrint.push(reservation)
      return true;
    })

    this.setState({
      [key] : check ? "yes" : "no",
      reservationIdsToPrint : reservationIdsToPrint,
      reservationsToPrint : reservationsToPrint,
    });
  };


  calculatePlanTotal = (plans, isJalan, jalanPaid, extraCharge, discount, gotoDiscount, jalanCoupon, jalanPoint, jalanSubsidy, taxRate) => {
    let gotoDiscountX = "no"
    if(gotoDiscount){
      gotoDiscountX = gotoDiscount
    }

    let total = 0;

    if(jalanPaid === "yes"){
      return total;
    }

    plans.map(n => {
      total += (Number(n.unitPrice) * Number(n.amount))
      return true;
    })

    if(isJalan === "no"){
      total += Number(extraCharge);
      total -= Number(discount);

      if(gotoDiscountX === "yes"){

        total = Math.floor(total * (1 + Number(taxRate))) - Math.ceil(total * (1 + Number(taxRate)) * 0.35)
      }
    }

    if(isJalan === "yes"){
      total -= Number(jalanCoupon);
      total -= Number(jalanPoint);
      total -= Number(jalanSubsidy);
    }


    return total;
  }

  calculateTaxTotal = (plans, isJalan, jalanPaid, extraCharge, discount, gotoDiscount, jalanCoupon, jalanPoint, jalanSubsidy, orders, taxRate) => {
    let gotoDiscountX = "no"
    if(gotoDiscount){
      gotoDiscountX = gotoDiscount
    }

    let tax = 0;

    if(isJalan === "no" && gotoDiscountX === "no"){
      tax += Math.floor(this.calculatePlanTotal(plans, isJalan, jalanPaid, extraCharge, discount, gotoDiscountX, jalanCoupon, jalanPoint, jalanSubsidy, taxRate) * Number(taxRate))
    }

    if(isJalan === "yes"  || gotoDiscountX === "yes"){
      tax += Math.floor(this.calculatePlanTotal(plans, isJalan, jalanPaid, extraCharge, discount, gotoDiscountX, jalanCoupon, jalanPoint, jalanSubsidy, taxRate) * (Number(taxRate)) / (1 + Number(taxRate)))
    }

    tax += Math.floor(this.calculateOrderOuterTaxTotal(orders) * Number(taxRate))

    tax += Math.floor(this.calculateOrderInnerTaxTotal(orders) * (Number(taxRate)) / (1 + Number(taxRate)))

    return tax;

  }

  calculateTotal = (plans, isJalan, jalanPaid, extraCharge, discount, gotoDiscount, jalanCoupon, jalanPoint, jalanSubsidy, orders, taxRate) => {
    let gotoDiscountX = "no"
    if(gotoDiscount){
      gotoDiscountX = gotoDiscount
    }

    let total = 0;

    if(isJalan === "no" && gotoDiscountX === "no"){
      total += Math.floor(this.calculatePlanTotal(plans, isJalan, jalanPaid, extraCharge, discount, gotoDiscountX, jalanCoupon, jalanPoint, jalanSubsidy, taxRate) * (1 + Number(taxRate)))
    }

    if(isJalan === "yes" || gotoDiscountX === "yes"){
      total += this.calculatePlanTotal(plans, isJalan, jalanPaid, extraCharge, discount, gotoDiscountX, jalanCoupon, jalanPoint, jalanSubsidy, taxRate)
    }

    total += Math.floor(this.calculateOrderOuterTaxTotal(orders) * (1 + Number(taxRate)))

    total += this.calculateOrderInnerTaxTotal(orders)

    return total;

  }

  calculateOrderOuterTaxTotal = (orders) => {
    let total = 0;

    orders.map(n => {
      if(n.taxType === "税別"){
        total += Number(n.price) * Number(n.amount)
      }
      return true;
    })

    return total;
  }

  calculateOrderInnerTaxTotal = (orders,taxRate) => {
    let total = 0;

    orders.map(n => {
      if(n.taxType === "税込"){
        total += Number(n.price) * Number(n.amount)
      }
      return true;
    })

    return total;
  }

  onAfterPrint = () => {
    let receiptNumbersToPrint = [];

    this.state.reservationsToPrint.map(n => {
      let receiptNumber = uuidv4() + "-" + n.date;
      let receiptNumberItem = {
        reservationId: n.reservation_id,
        receiptNumber: receiptNumber,
      }

      receiptNumbersToPrint.push(receiptNumberItem);

      this.setState({
        [ n.reservation_id + "ReceiptNumber" ] : receiptNumber,
        receiptNumbersToPrint: receiptNumbersToPrint
      })
      return true;
    })

    let apiName = 'MyAPIGatewayAPI';
    let path = '/add-receipt';

    let body = {
      receiptNumbersToPrint: this.state.receiptNumbersToPrint,
    };

    let myInit = {
      body: body, // replace this with attributes you need
    }

    API.post(apiName, path, myInit).then(response => {
      console.log(response);
    }).catch(error => {
      console.log(error);
    })
  }

  onAfterPrintAll = () => {
    let receiptNumbers = [];

    this.state.reservations.map(n => {
      let receiptNumber = uuidv4() + "-" + n.date;
      let receiptNumberItem = {
        reservationId: n.reservation_id,
        receiptNumber: receiptNumber,
      }

      receiptNumbers.push(receiptNumberItem);

      this.setState({
        [ n.reservation_id + "ReceiptNumber" ] : receiptNumber,
        receiptNumbers: receiptNumbers
      })
      return true;
    })

    let apiName = 'MyAPIGatewayAPI';
    let path = '/add-receipt';

    let body = {
      receiptNumbers: this.state.receiptNumbers,
    };

    let myInit = {
      body: body, // replace this with attributes you need
    }

    API.post(apiName, path, myInit).then(response => {
      console.log(response);
    }).catch(error => {
      console.log(error);
    })
  }

  render() {
    const {classes} = this.props
    const {
      reservations,

    } = this.state;

    return (
      <Fragment>
        <Grid container spacing={24} className={classes.container}>
          <Grid item xs={12}>
            <Typography variant="h4" gutterBottom>
              領収書発行
            </Typography>
          </Grid>
          <Grid item xs={12}>

            <Typography variant="h6" gutterBottom　style={{display: reservations.length === 0 ? "" : "none"}}>
              表示する予約がありません
            </Typography>

            <div style={{display: reservations.length === 0 ? "none" : ""}}>
              <ReactToPrint
                trigger={() => {
                  return(
                    <Button size="small" variant="contained"  color="primary" className={classes.menuButton} style={{marginTop:10}}>
                      選択した領収書を発行
                    </Button>
                  )
                }}
                content={() => this.componentRef}
                onAfterPrint ={() => this.onAfterPrint()}
              />
              <ReactToPrint
                trigger={() => {
                  return(
                    <Button size="small" variant="contained"  color="secondary" className={classes.menuButton} style={{marginTop:10}}>
                      全ての領収書を発行
                    </Button>
                  )
                }}
                content={() => this.componentRefAll}
                onAfterPrint ={() => this.onAfterPrintAll()}
              />
            </div>
          </Grid>
          <Grid item>



          {reservations.map(n => {

            let rooms = "";
            for(let i in n.input_rooms){
              rooms = rooms + n.input_rooms[i]
              if(i !== n.input_rooms.length - 1){
                rooms = rooms + " "
              }
            }

            if(reservations.length > 0){
              return (
                <Paper key={n.reservation_id} className={classes.root} elevation={1} style={{marginBottom:30}}>
                  <Grid container spacing={24} className={classes.container}>
                    <Grid item xs={1}>
                      <Checkbox
                        checked={this.state[n.reservation_id + "PrintCheck"] === "yes" ? true : false}
                        onChange={(e) => this.handleChangeCheck(e, n.reservation_id + "PrintCheck")}
                        value={n.reservation_id + "PrintCheck"}
                        color="primary"
                        style={{padding:0, margin:0, marginTop:20}}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <Typography variant="h6" style={{marginTop:17, marginLeft:5}}>
                        {n.last_name} {n.first_name} <div style={{marginLeft: 10, fontSize:"0.8em", display: "inline"}}>様</div>
                      </Typography>
                    </Grid>
                    <Grid item xs={1}>
                      <Typography variant="caption" style={{marginLeft:7,marginTop:20}}>
                        お部屋
                      </Typography>
                      <Typography variant="body1" style={{marginLeft:12}}>
                        {rooms}
                      </Typography>
                    </Grid>
                    <Grid item xs={3}>
                      <Typography variant="caption" style={{marginLeft:7,marginTop:20}}>
                        宿泊開始日
                      </Typography>
                      <Typography variant="body1" style={{marginLeft:12}}>
                        {moment(n.date).format("YYYY年MM月DD日(ddd)")}
                      </Typography>
                    </Grid>
                    <Grid item xs={2}>
                      <Typography variant="caption" style={{marginLeft:7,marginTop:20}}>
                        泊数
                      </Typography>
                      <Typography variant="body1" style={{marginLeft:12}}>
                        {n.date_num}泊
                      </Typography>
                    </Grid>

                    {(() => {
                       if (n.jalan_number){
                         return (
                           <Grid item xs={3}>
                             <Typography variant="caption" style={{marginLeft:7,marginTop:20}}>
                               じゃらんNo.
                             </Typography>
                             <Typography variant="body1" style={{marginLeft:12}}>
                               {n.jalan_number}
                             </Typography>
                           </Grid>
                         )
                       }else{
                         return (
                           <Grid item xs={3}>
                           </Grid>
                         )
                       }
                     })()}


                    <Grid item xs={1}>
                    </Grid>
                    <Grid item xs={11}>
                      <Table className={classes.table} style={{marginTop: 20, marginBottom:20}}>
                        <TableHead style={{backgroundColor:"#f3f3f3"}}>
                          <TableRow>
                            <TableCell className={classes.longTableCell} align="left" padding="dense">品名</TableCell>
                            <TableCell style={{color: "#676767"}} align="center" padding="dense">単価</TableCell>
                            <TableCell style={{color: "#676767"}} align="center" padding="dense">数量</TableCell>
                            <TableCell style={{color: "#676767"}} align="center" padding="dense">消費税区分</TableCell>
                            <TableCell style={{color: "#676767"}} align="center" padding="dense">小計</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody key={n.reservation_id}>
                          {n.plans.map((m,i) => {
                            if(n.is_jalan === "no"){
                              return(
                                <TableRow key={"notJalan" + i}>
                                  <TableCell className={classes.longTableCell} align="left" padding="dense">{m.basePlan}ご宿泊料({m.mealPlan}・ベッド{m.bedPlan})</TableCell>
                                  <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ {Number(m.unitPrice).toLocaleString()}</TableCell>
                                  <TableCell style={{color: "#676767"}} align="right" padding="dense">{m.amount}</TableCell>
                                  <TableCell style={{color: "#676767"}} align="center" padding="dense">税別</TableCell>
                                  <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ {(Number(m.unitPrice) * Number(m.amount)).toLocaleString()}</TableCell>
                                </TableRow>
                              )
                            }

                            if(n.is_jalan === "yes"){
                              return(
                                <TableRow key={"jalan" + i}>
                                  <TableCell className={classes.longTableCell} align="left" padding="dense">じゃらん {m.basePlan}ご宿泊料({m.mealPlan}・ベッド{m.bedPlan})</TableCell>
                                  <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ {Number(m.unitPrice).toLocaleString()}</TableCell>
                                  <TableCell style={{color: "#676767"}} align="right" padding="dense">{m.amount}</TableCell>
                                  <TableCell style={{color: "#676767"}} align="center" padding="dense">税込</TableCell>
                                  <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ {(Number(m.unitPrice) * Number(m.amount)).toLocaleString()}</TableCell>
                                </TableRow>
                              )
                            }

                            return true;

                          })}

                          {(() => {

                            if (n.is_jalan === "no" && n.extra_charge && n.discount){
                              return (
                                <Fragment>
                                  <TableRow>
                                    <TableCell className={classes.longTableCell} align="left" padding="dense">その他サービス料</TableCell>
                                    <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                                    <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                                    <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                                    <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ {Number(n.extra_charge).toLocaleString()}</TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell className={classes.longTableCell} align="left" padding="dense">割引額</TableCell>
                                    <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                                    <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                                    <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                                    <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ -{Number(n.discount).toLocaleString()}</TableCell>
                                  </TableRow>
                                </Fragment>
                              )
                            }

                            if (n.is_jalan === "no" && n.extra_charge){
                              return (
                                <TableRow>
                                  <TableCell className={classes.longTableCell} align="left" padding="dense">その他サービス料</TableCell>
                                  <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                                  <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                                  <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                                  <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ {Number(n.extra_charge).toLocaleString()}</TableCell>
                                </TableRow>
                              )
                            }

                            if (n.is_jalan === "no" && n.discount){
                              return (
                                <TableRow>
                                  <TableCell className={classes.longTableCell} align="left" padding="dense">割引額</TableCell>
                                  <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                                  <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                                  <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                                  <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ -{Number(n.discount).toLocaleString()}</TableCell>
                                </TableRow>
                              )
                            }


                            if (n.is_jalan === "yes" && n.jalan_coupon && n.jalan_point && n.jalan_subsidy){
                              return (
                                <Fragment>
                                  <TableRow>
                                    <TableCell className={classes.longTableCell} align="left" padding="dense">じゃらんクーポン利用額</TableCell>
                                    <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                                    <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                                    <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                                    <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ -{n.jalan_coupon}</TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell className={classes.longTableCell} align="left" padding="dense">じゃらんポイント利用額</TableCell>
                                    <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                                    <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                                    <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                                    <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ -{n.jalan_point}</TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell className={classes.longTableCell} align="left" padding="dense">補助金利用額</TableCell>
                                    <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                                    <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                                    <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                                    <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ -{n.jalan_subsidy}</TableCell>
                                  </TableRow>
                                </Fragment>
                              )
                            }

                            if (n.is_jalan === "yes" && n.jalan_coupon && n.jalan_point){
                              return (
                                <Fragment>
                                  <TableRow>
                                    <TableCell className={classes.longTableCell} align="left" padding="dense">じゃらんクーポン利用額</TableCell>
                                    <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                                    <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                                    <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                                    <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ -{n.jalan_coupon}</TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell className={classes.longTableCell} align="left" padding="dense">じゃらんポイント利用額</TableCell>
                                    <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                                    <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                                    <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                                    <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ -{n.jalan_point}</TableCell>
                                  </TableRow>
                                </Fragment>
                              )
                            }

                            if (n.is_jalan === "yes" && n.jalan_coupon && n.jalan_subsidy){
                              return (
                                <Fragment>
                                  <TableRow>
                                    <TableCell className={classes.longTableCell} align="left" padding="dense">じゃらんクーポン利用額</TableCell>
                                    <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                                    <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                                    <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                                    <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ -{n.jalan_coupon}</TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell className={classes.longTableCell} align="left" padding="dense">補助金利用額</TableCell>
                                    <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                                    <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                                    <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                                    <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ -{n.jalan_subsidy}</TableCell>
                                  </TableRow>
                                </Fragment>
                              )
                            }

                            if (n.is_jalan === "yes" && n.jalan_point && n.jalan_subsidy){
                              return (
                                <Fragment>
                                  <TableRow>
                                    <TableCell className={classes.longTableCell} align="left" padding="dense">じゃらんポイント利用額</TableCell>
                                    <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                                    <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                                    <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                                    <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ -{n.jalan_point}</TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell className={classes.longTableCell} align="left" padding="dense">補助金利用額</TableCell>
                                    <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                                    <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                                    <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                                    <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ -{n.jalan_subsidy}</TableCell>
                                  </TableRow>
                                </Fragment>
                              )
                            }

                            if (n.is_jalan === "yes" && n.jalan_coupon){
                              return (
                                <TableRow>
                                  <TableCell className={classes.longTableCell} align="left" padding="dense">じゃらんクーポン利用額</TableCell>
                                  <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                                  <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                                  <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                                  <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ -{n.jalan_coupon}</TableCell>
                                </TableRow>
                              )
                            }

                            if (n.is_jalan === "yes" && n.jalan_point){
                              return (
                                <TableRow>
                                  <TableCell className={classes.longTableCell} align="left" padding="dense">じゃらんポイント利用額</TableCell>
                                  <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                                  <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                                  <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                                  <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ -{n.jalan_point}</TableCell>
                                </TableRow>
                            )
                            }
                            if (n.is_jalan === "yes" && n.jalan_subsidy){
                              return (
                                <TableRow>
                                  <TableCell className={classes.longTableCell} align="left" padding="dense">補助金利用額</TableCell>
                                  <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                                  <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                                  <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                                  <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ -{n.jalan_subsidy}</TableCell>
                                </TableRow>
                              )
                            }

                           })()}


                           {(() => {
                              if (n.is_jalan === "yes" && n.jalan_paid === "yes"){
                                return (
                                  <TableRow style={{backgroundColor:"#f3f3f3"}}>
                                    <TableCell className={classes.longTableCell} align="left" padding="dense">じゃらんお支払い済み金額</TableCell>
                                    <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                                    <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                                    <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                                    <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ -{this.calculatePlanTotal(n.plans, n.is_jalan, "no", n.extra_charge, n.discount, n.goto_discount, n.jalan_coupon, n.jalan_point, n.jalan_subsidy, n.tax_rate).toLocaleString()}</TableCell>
                                  </TableRow>
                                )
                              }
                            })()}

                            {(() => {
                               if (n.goto_discount === "yes"){
                                 return (
                                   <TableRow>
                                     <TableCell className={classes.longTableCell} align="left" padding="dense">GoToキャンペーン割引額</TableCell>
                                     <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                                     <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                                     <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                                     <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ -{Math.ceil(this.calculatePlanTotal(n.plans, n.is_jalan, n.jalan_paid, n.extra_charge, n.discount, "no", n.jalan_coupon, n.jalan_point, n.jalan_subsidy, n.tax_rate) * 1.1 * 0.35).toLocaleString()}</TableCell>
                                   </TableRow>
                                 )
                               }
                             })()}


                          <TableRow style={{backgroundColor:"#f3f3f3"}}>
                            <TableCell className={classes.longTableCell} align="left" padding="dense">ご宿泊料小計</TableCell>
                            <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                            <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                            <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                            <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ {this.calculatePlanTotal(n.plans, n.is_jalan, n.jalan_paid, n.extra_charge, n.discount, n.goto_discount, n.jalan_coupon, n.jalan_point, n.jalan_subsidy, n.tax_rate).toLocaleString()}</TableCell>
                          </TableRow>

                          {(() => {
                             if ((n.is_jalan === "yes" && n.jalan_paid === "no") || n.goto_discount === "yes"){
                               return (
                                 <TableRow style={{backgroundColor:"#f3f3f3"}}>
                                   <TableCell className={classes.longTableCell} align="left" padding="dense">( 内消費税</TableCell>
                                   <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                                   <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                                   <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                                   <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ {
                                     Math.floor(this.calculatePlanTotal(n.plans, n.is_jalan, n.jalan_paid, n.extra_charge, n.discount, n.goto_discount, n.jalan_coupon, n.jalan_point, n.jalan_subsidy, n.tax_rate) * (Number(n.tax_rate)) / (1 + Number(n.tax_rate))).toLocaleString()
                                   } )</TableCell>
                                 </TableRow>
                               )
                             }
                           })()}

                          <TableRow>
                            <TableCell className={classes.longTableCell} align="left" padding="dense"></TableCell>
                            <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                            <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                            <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                            <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                          </TableRow>

                          {(() => {
                             if (this.calculateOrderOuterTaxTotal(n.orders) > 0){
                               return (
                                 <Fragment>
                                   {n.orders.map((m,i) => {
                                     if(m.taxType === "税別"){
                                       return(
                                         <TableRow key={m.name + "outerTax" +  i}>
                                           <TableCell className={classes.longTableCell} align="left" padding="dense">{m.name}</TableCell>
                                           <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ {Number(m.price).toLocaleString()}</TableCell>
                                           <TableCell style={{color: "#676767"}} align="right" padding="dense">{m.amount}</TableCell>
                                           <TableCell style={{color: "#676767"}} align="center" padding="dense">{m.taxType}</TableCell>
                                           <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ {(Number(m.price) * Number(m.amount)).toLocaleString()}</TableCell>
                                         </TableRow>
                                       )
                                     }
                                     return true;
                                    })}
                                    <TableRow style={{backgroundColor:"#f3f3f3"}}>
                                      <TableCell className={classes.longTableCell} align="left" padding="dense">税別ご飲食費小計</TableCell>
                                      <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                                      <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                                      <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                                      <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ {this.calculateOrderOuterTaxTotal(n.orders).toLocaleString()}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                      <TableCell className={classes.longTableCell} align="left" padding="dense"></TableCell>
                                      <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                                      <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                                      <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                                      <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                                    </TableRow>
                                  </Fragment>
                               )
                             }
                           })()}

                           {(() => {
                              if (this.calculateOrderInnerTaxTotal(n.orders) > 0){
                                return (
                                  <Fragment>
                                    {n.orders.map((m,i) => {
                                      if(m.taxType === "税込"){
                                        return(
                                          <TableRow key={m.name + "innerTax" +  i}>
                                            <TableCell className={classes.longTableCell} align="left" padding="dense">{m.name}</TableCell>
                                            <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ {Number(m.price).toLocaleString()}</TableCell>
                                            <TableCell style={{color: "#676767"}} align="right" padding="dense">{m.amount}</TableCell>
                                            <TableCell style={{color: "#676767"}} align="center" padding="dense">{m.taxType}</TableCell>
                                            <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ {(Number(m.price) * Number(m.amount)).toLocaleString()}</TableCell>
                                          </TableRow>
                                        )
                                      }
                                      return true;
                                    })}
                                    <TableRow style={{backgroundColor:"#f3f3f3"}}>
                                      <TableCell className={classes.longTableCell} align="left" padding="dense">税込ご飲食費小計</TableCell>
                                      <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                                      <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                                      <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                                      <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ {this.calculateOrderInnerTaxTotal(n.orders).toLocaleString()}</TableCell>
                                    </TableRow>
                                    <TableRow style={{backgroundColor:"#f3f3f3"}}>
                                      <TableCell className={classes.longTableCell} align="left" padding="dense">( 内消費税</TableCell>
                                      <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                                      <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                                      <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                                      <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ {
                                        Math.floor(this.calculateOrderInnerTaxTotal(n.orders) * (Number(n.tax_rate)) / (1 + Number(n.tax_rate))).toLocaleString()
                                      } )</TableCell>
                                    </TableRow>
                                    <TableRow>
                                      <TableCell className={classes.longTableCell} align="left" padding="dense"></TableCell>
                                      <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                                      <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                                      <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                                      <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                                    </TableRow>
                                   </Fragment>
                                )
                              }
                            })()}

                          <TableRow style={{backgroundColor:"#f3f3f3"}}>
                            <TableCell className={classes.longTableCell} align="left" padding="dense">消費税等小計 ({Number(n.tax_rate) * 100}%)</TableCell>
                            <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                            <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                            <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                            <TableCell style={{color: "#676767"}} align="right" padding="dense">¥ {this.calculateTaxTotal(n.plans, n.is_jalan, n.jalan_paid, n.extra_charge, n.discount, n.goto_discount, n.jalan_coupon, n.jalan_point, n.jalan_subsidy, n.orders, n.tax_rate).toLocaleString()}</TableCell>
                          </TableRow>
                          <TableRow style={{backgroundColor:"#d0d0d0"}}>
                            <TableCell className={classes.longTableCell} align="left" padding="dense">合計</TableCell>
                            <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                            <TableCell style={{color: "#676767"}} align="right" padding="dense"></TableCell>
                            <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                            <TableCell style={{color: "#676767"}} align="right" padding="dense">￥ {this.calculateTotal(n.plans, n.is_jalan, n.jalan_paid, n.extra_charge, n.discount, n.goto_discount, n.jalan_coupon, n.jalan_point, n.jalan_subsidy, n.orders, n.tax_rate).toLocaleString()}</TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={(e) => this.handleChangeCheck(e, n.reservation_id + 'CreditCheck')}
                            value={n.reservation_id + 'CreditCheck'}
                            checked={this.state[n.reservation_id + "CreditCheck"] === "yes" ? true : false }
                            color="secondary"
                          />
                        }
                        label="クレジットカード利用"
                        style={{marginTop:20, marginLeft:-5}}
                      />
                      <TextField
                        label="領収書備考"
                        className={classes.textField}
                        value={this.state[n.reservation_id + "ReceiptNote"] ? this.state[n.reservation_id + "ReceiptNote"] : ""}
                        onChange={(e) => this.handleChange(e, n.reservation_id + "ReceiptNote")}
                        margin="normal"
                        style={{width: "98%", marginTop: 15, marginBottom: 15}}
                      />
                      <TextField
                        className={classes.textField}
                        name="issueDate"
                        label="領収書発行日"
                        value={this.state[n.reservation_id + "IssueDate"] ? this.state[n.reservation_id + "IssueDate"] : ""}
                        margin="normal"
                        onChange={(e) => this.handleChange(e, n.reservation_id + "IssueDate")}
                        type="date"
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Grid>
                  </Grid>
                </Paper>
              )
            }
            return true;
          })}

          </Grid>
        </Grid>
        <Receipt ref={el => (this.componentRef = el)} state={this.state}/>
        <ReceiptAll ref={el => (this.componentRefAll = el)} state={this.state}/>
      </Fragment>
    );
  }
}

IssueReceipts.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withSnackbar(withRouter(withStyles(styles, { withTheme: true })(IssueReceipts)));
